import { default as feedbackBot } from './bot/routes'
import { default as alertMessages } from './alert/routes'

export default [
    ...feedbackBot,
    ...alertMessages
]